/**
 * CosmeticEvents — unlock toasts for cosmeticsUnlocked.
 *
 * The server emits this directly to the player who just crossed a stat
 * threshold. Each item becomes one NotificationSystem success toast, and
 * onUnlocked applies the same items to the locker store so ownership is
 * visible without a page reload.
 */

const CosmeticEvents = {
  /**
   * @param {Socket} socket
   * @param {GameState} _gameState
   * @param {Object} callbacks
   * @param {Function} callbacks.notifySuccess
   * @param {Function} callbacks.onUnlocked
   */
  register(socket, _gameState, callbacks) {
    const { notifySuccess = () => {}, onUnlocked = () => {} } = callbacks;
    socket.on('cosmeticsUnlocked', (data) => {
      const items = data && Array.isArray(data.items) ? data.items : [];
      if (items.length) onUnlocked(items);
      for (const item of items) {
        if (!item || !item.name) continue;
        notifySuccess(`Unlocked: ${item.name}!`);
      }
    });
  }
};

export { CosmeticEvents };
